import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import compose from 'recompose/compose'
import { withTranslate } from 'react-redux-multilingual'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import Reservation from '../modules/reservation'
import BookingInfoPayment from './BookingInfoPayment'
import * as CreditCardValidator from 'card-validator'

import Loading from './Loading'
import Success from './Success'
import Error from './Error'
import ErrorMessage from './ErrorMessage'
import { CardContent, Grid } from '@material-ui/core'
import StringHelper from '../helpers/string-helper'
import { getIssuer } from '../helpers/credit_card'
import { CardPayment } from '@mercadopago/sdk-react'
import PaymentGateways from '../config/paymentGateways'
import memoizeOne from 'memoize-one'
import MaskHelper from '../helpers/mask-helper'
import i18nHelper from '../helpers/i18n-helper'
import DocumentTypes from '../config/documentTypes'
import ValidationHelper from '../helpers/validation-helper'

class PaymentStep extends React.Component {
  state = {
    loading: true,
    activeStep: 'guest-payment',
    bookingInfo: {
      id: -1,
      check_in_date: null,
      check_out_date: null,
      name: '',
      edp: '',
      debit: 0,
      country_id: null,
    },
    payment: {
      guest_email: '',
      guest_phone: '',
      guest_document_type: '',
      guest_document_number: '',
      cc_number: '',
      cc_name: '',
      cc_valid_thru: '',
      cc_code: '',
      cc_issuer: '',
      cc_payment_amount: 0,
      cc_installments: 1,
      cc_document_type: '',
      cc_document_number: '',
      mp_token: '',
      mp_installments:'',
      mp_payment_method_id:'',
      mp_email:'',
      mp_identification_type: '',
      mp_identification_number: '',
    },
    propertyInfo: {
      property_name: ''
    },
    valid: true,
    isValid: true,
    creditCardValidationStatus: {
      number: true,
      name: true,
      expiration: true,
      cvv: true,
      document_type: true,
      document_number: true,
      amount: true,
      installments: true
    },
    save_success: false,
    payment_under_analysis_message: '',
    save_message: '',
    dateIn: new Date(),
    dateOut: new Date(),
    error_message: null
  }

  constructor(props) {
    super(props)

    this.validate = this.validate.bind(this)
    this.saveForm = this.saveForm.bind(this)
    this.resetSteps = this.resetSteps.bind(this)
  }

  async componentDidMount() {

    const defaultLocale = this.props.locale

    const reservation = this.props.reservation.data

    if (reservation) {
      const dateIn = new Date(
        Date.UTC(
          +reservation.bookingInfo.check_in_date.split('-')[0],
          +reservation.bookingInfo.check_in_date.split('-')[1] - 1,
          parseInt(
            reservation.bookingInfo.check_in_date.split('-')[2],
            10
          ) + 1,
          0,
          0,
          0
        )
      )

      const dateOut = new Date(
        Date.UTC(
          +reservation.bookingInfo.check_out_date.split('-')[0],
          +reservation.bookingInfo.check_out_date.split('-')[1] - 1,
          parseInt(
            reservation.bookingInfo.check_out_date.split('-')[2],
            10
          ) + 1,
          0,
          0,
          0
        )
      )

      const activePaymentGatewayIsMercadoPago = parseInt(reservation.paymentInfo?.payment_gateway_id, 10) === PaymentGateways.MP; 
      const paymentGatewayPublicKey = reservation.paymentInfo?.payment_gateway_public_key; 
      const showMercadoPagoCardPayment = activePaymentGatewayIsMercadoPago && paymentGatewayPublicKey; 

      const step = showMercadoPagoCardPayment ? 'guest-payment-mercadopago' : this.state.activeStep; 

      const countryId = parseInt(reservation.bookingInfo.country_id);
      const isBrazilian = countryId === i18nHelper.BRAZIL_ID;

      let phoneNumber = reservation.bookingInfo.phone_with_area_code;
      if(parseInt(reservation.bookingInfo.country_id) === i18nHelper.BRAZIL_ID && !ValidationHelper.isValidBrazilianPhone(phoneNumber)){
        phoneNumber = '';
      } else {
        phoneNumber = MaskHelper.formatBrazilianPhone(reservation.bookingInfo.phone_with_area_code) 
      }

      this.setState({
        bookingInfo: { 
          ...reservation.bookingInfo, 
          guest_email: reservation.bookingInfo.email,
          guest_country_id: reservation.bookingInfo.country_id
        },
        paymentInfo: reservation.paymentInfo,
        payment: {
          ...reservation.bookingInfo,
          guest_email: reservation.bookingInfo.email,
          guest_phone: phoneNumber,
          cc_document_type: isBrazilian ? DocumentTypes.CPF : DocumentTypes.PASSPORT,
          guest_document_type: isBrazilian ? DocumentTypes.CPF : DocumentTypes.PASSPORT,
          guest_document_number: reservation.bookingInfo.document_number, 
          cc_payment_amount: sessionStorage.getItem('paymentAmount')
        },
        propertyInfo: reservation.propertyInfo,
        dateIn: dateIn,
        dateOut: dateOut,
        activeStep: step,
        originalStep: step,
        maxInstallments: reservation.paymentInfo?.payment_gateway_installments_limit ?? 1,
        showMercadoPagoCardPayment,
        defaultLocale
      });
    }

    this.setState({ loading: false })
  }

  
  handlePaymentChange = (name, value) => {
    this.setState({
      payment: {
        ...this.state.payment,
        [name]: value
      }
    })
  }

  handleChange = (event) => {
    const name = event.target.name
    this.setState((prevState) => ({
      payment: {
        ...prevState.payment,
        [name]: event.target.value
      }
    }))
  }

  // endregion

  resetSteps = () => {
    this.setState({
      save_success: false,
      save_message: '',
      activeStep: this.state.originalStep,
      payment: {
        cc_number : '',
        cc_name : '',
        cc_document_number : '',
        cc_valid_thru : '',
        cc_code : '',
        cc_issuer : '',
        guest_document_type: this.state.selectedGuestDocumentTypeChoice,
        cc_document_type: this.state.selectedDocumentTypeChoice,
        cc_payment_amount : this.state.payment.cc_payment_amount
      }
    })
  }

  getMPConfig = memoizeOne((amount, defaultLocale, maxInstallments = 1) => {
      return {
        initialization: {
          amount: Number.parseFloat(amount),
          locale: defaultLocale,
        },
        customization: {
          visual: {
            hideFormTitle: true,
            hidePaymentButton: true,
          },
          paymentMethods: {
            minInstallments: 1,
            maxInstallments: maxInstallments,
            types: {
              excluded: ['debit_card'],
            },
          },
        },
      };
   });


  getStepContent(step) {
    switch (step) {

      case 'guest-payment':
      default: {
        return (
          <BookingInfoPayment
            payment={this.state.payment}
            paymentInfo={this.props.paymentInfo}
            bookingInfo={this.state.bookingInfo}
            validationStatus={this.state.creditCardValidationStatus}
            handlePaymentChange={this.handlePaymentChange}
            propertyName={this.state.propertyInfo.property_name}
            propertyLocale={this.state.propertyInfo.country_code}
          />
        )
      }

      case 'guest-payment-mercadopago':
        return (
          <CardPayment {...this.getMPConfig(this.state.payment.cc_payment_amount, this.state.defaultLocale, this.state.maxInstallments)} />
        )

      case 'success': {
        return this.state.save_success ? (
          <Success propertyName={this.state.propertyInfo.property_name} paymentUnderAnalysisMessage={this.state.payment_under_analysis_message} />
        ) : (
          <Error message={this.state.error_message} />
        )
      }
    }
  }

  validate() {
    
    const cc_issuer = getIssuer(this.state.payment.cc_number);
    const ccIssuerAcceptableCvvLength = (cc_issuer === 'amex') ? [3,4] : [3];
    const numberValidation = CreditCardValidator.number(this.state.payment.cc_number);

    const {guest_document_type, guest_document_number, cc_document_type, cc_document_number} = this.state.payment;
    
    let guestDocumentNumberValidation = false; 
    let ccDocumentNumberValidation = false;
    if(guest_document_type !== DocumentTypes.PASSPORT){
      guestDocumentNumberValidation = guest_document_type === DocumentTypes.CPF ? ValidationHelper.isValidCPF(guest_document_number) : ValidationHelper.isValidCNPJ(guest_document_number);
    } else {
      guestDocumentNumberValidation = ValidationHelper.isValidPassport(guest_document_number);
    }

    if(cc_document_type !== DocumentTypes.PASSPORT){
      ccDocumentNumberValidation = cc_document_type === DocumentTypes.CPF ? ValidationHelper.isValidCPF(cc_document_number) : ValidationHelper.isValidCNPJ(cc_document_number);
    } else {
      ccDocumentNumberValidation = ValidationHelper.isValidPassport(cc_document_number);
    }

    const validThruValidation = CreditCardValidator.expirationDate(this.state.payment.cc_valid_thru);
    const codeValidation = CreditCardValidator.cvv(this.state.payment.cc_code, ccIssuerAcceptableCvvLength);

    let balanceValidation = true;
    
    this.setState({ error_message: null })

    if (parseFloat(this.state.payment.cc_payment_amount) > parseFloat(this.state.bookingInfo.debit)) {
      this.setState({ error_message: this.props.translate('balanceSmallerThanPaymentError') })
      balanceValidation = false;
    }

    if (
      !numberValidation.isValid ||
      this.state.payment.cc_name === '' ||
      !validThruValidation.isValid ||
      !codeValidation.isValid ||
      !balanceValidation ||
      !guestDocumentNumberValidation ||
      !ccDocumentNumberValidation
    ) {
      return false
    }

    return true
  }


  processPayment = () => {

    this.setState({ loading: true })

    const clientSessionId = sessionStorage.getItem('clearSaleSessionId');
    
    const paymentData = { 
      ...this.state.payment,
      clientSessionId: clientSessionId,
      language: this.props.locale
    };

    Reservation.save(paymentData).then((response) => {

      this.setState({ error_message: null, save_success: response.status })

      if (
        response.hasOwnProperty('status') &&
        response.status === false &&
        response.result.hasOwnProperty('error_message') &&
        response.result.error_message !== ''
      ) {
        this.setState({
          error_message: response.result.error_message
        })
      } else if (!response) {
        this.setState({
          error_message: this.props.translate('generalErrorMessage')
        })
      } else if (
        response.hasOwnProperty('status') &&
        response.status === true
      ) {
        this.setState({
          error_message: null,
          save_success: true,
          activeStep: 'success'
        })
      }

      this.setState({ loading: false })
    });
  }

  processPaymentWithMercadoPago = () => {
    
    window.cardPaymentBrickController
      .getFormData()
      .then((cardFormData) => {
        
        if (StringHelper.isNotEmpty(cardFormData?.token)) {
          
          this.setState({ loading: true });

          const paymentData = { 
            ...this.state.payment,
            language: this.props.locale,
            mp_token: cardFormData?.token,
            mp_payment_method_id: cardFormData?.payment_method_id,
            mp_installments: cardFormData?.installments,
            mp_email: cardFormData?.payer?.email,
            mp_identification_type: cardFormData?.payer?.identification?.type,
            mp_identification_number: cardFormData?.payer?.identification?.number
          };

          Reservation.save(paymentData).then((response) => {

            this.setState({ error_message: null, save_success: response.status })

            if (
              response.hasOwnProperty('status') &&
              response.status === false &&
              response.result.hasOwnProperty('error_message') &&
              response.result.error_message !== ''
            ) {
              this.setState({
                error_message: response.result.error_message
              })
            } else if (!response) {
              this.setState({
                error_message: this.props.translate('generalErrorMessage')
              })
            } else if (
              response.hasOwnProperty('status') &&
              response.status === true
            ) {
              this.setState({
                error_message: null,
                save_success: true,
                payment_under_analysis_message: response?.result?.payment_under_analysis_message ?? '',
                activeStep: 'success'
              })
            }

            this.setState({ loading: false })
          })

        }

      })
      .catch((error) => {
        this.setState({ loading: false })
        // error handling when calling getFormData()
    });


  }

  saveForm = () => {
    if(this.state.activeStep === 'guest-payment-mercadopago'){
      this.processPaymentWithMercadoPago();
    } else {
      if (this.validate()) {
        this.processPayment();
      }
    }
  }

  handleSave = () => {
    this.saveForm()
  }


  render() {
    const { classes, translate } = this.props
    const { activeStep } = this.state

    return (
      <div className={classes.root}>
        {/* payment Header ( Booking main info ) */}
        <Paper square elevation={0} className={classes.header}>
          <div
            className={classes.div}
            style={{ display: this.state.loading ? 'none' : 'flex' }}
          >
            <Typography className={classes.title} component="p">
              {translate('reservationLabel')}
              <br /> {this.state.bookingInfo.tbk_id}
            </Typography>
            <Typography className={classes.title} component="p">
              Check in
              <br />{' '}
              {new Intl.DateTimeFormat(this.props.locale, {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
              }).format(this.state.dateIn)}{' '}
            </Typography>
            <Typography className={classes.title} component="p">
              Check out
              <br />{' '}
              {new Intl.DateTimeFormat(this.props.locale, {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
              }).format(this.state.dateOut)}{' '}
            </Typography>
          </div>
        </Paper>

        {this.state.loading ? (
          <Loading visible={this.state.loading} />
        ) : (
          <>
            {StringHelper.isNotEmpty(this.state.error_message) && (
              <ErrorMessage message={this.state.error_message} />
            )}
            {this.getStepContent(activeStep)}
          </>
        )}

        {activeStep !== 'success' && (
          <Grid item>
            <CardContent>
              <Button
                size="large"
                onClick={this.handleSave}
                disabled={this.state.loading}
                variant="contained"
                color="primary"
                fullWidth
              >
                {translate('payLabel')}
              </Button>
            </CardContent>
          </Grid>
        )}
      </div>
    )
  }
}


const styles = (theme) => ({
  root: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(550 + theme.spacing(2) * 2)]: {
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  },
  header: {
    alignItems: 'center',
    padding: theme.spacing(1),
    backgroundColor: '#303e46',
    width: '100%',
    overflow: 'hidden'
  },
  title: {
    color: '#fff',
    fontSize: '11px',
    width: '33.3%',
    marginLeft: 'auto',
    marginRight: 'auto',
    overflowWrap: 'break-word',
    padding: 2
  },
  div: {
    display: 'flex',
    textAlign: 'center'
  }
})

PaymentStep.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  translations: PropTypes.object
}

function mapPropsToState(state) {
  const { Intl, app, reservation } = state
  return { 
    ...Intl, 
    app: app, 
    reservation: reservation,
    key: Intl.locale 
  }
}

export default compose(
  withStyles(styles, { withTheme: true }),
  connect(mapPropsToState)
)(withTranslate(PaymentStep))
